@let skogsvardsAtgard = skogsvardsAtgard$ | async;

@if(skogsvardTradslagPlanta && skogsvardsAtgard){
  @let disabled = kontraktReadonly || skogsvardsAtgard.isReadonly || isLoading;
  <div class="row mb-3">
    <div class="col-9">
      <div class="row">
        @if(allatradslag?.length > 0){
          <rask-simple-selector
            label="Trädslag"
            [values]="allatradslag"
            [(ngModel)]="valttradslag"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            (change)="tradslagChanged($event)"
            class="col-3"
            bindLabel="externkod">
          </rask-simple-selector>
        }

        @if (aktuellaPlanttyper?.length > 0) {
          <rask-simple-selector
            class="col-3"
            label="Planttyp"
            [values]="aktuellaPlanttyper"
            [(ngModel)]="skogsvardTradslagPlanta.planttyp"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            (change)="planttypChanged($event)">
          </rask-simple-selector>
        }

        <rask-simple-selector
          class="col-3"
          label="Skydd"
          [clearable]="true"
          [values]="allowedPlantskydd"
          [(ngModel)]="skogsvardTradslagPlanta.plantskydd"
          [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
          (change)="somethingChanged($event)">
        </rask-simple-selector>
      </div>
      <div
        class="row"
        [ngClass]="{'justify-content-end': !skogsvardsAtgard.isPlantleverans}">
        <rask-input-number
          class="col-3"
          label="Plantantal"
          [(ngModel)]="skogsvardTradslagPlanta.plantantal"
          [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
          (change)="somethingChanged($event)"
          [useDecimalProcessor]="true"
          [isDecimal]="false">
        </rask-input-number>

        @if(!skogsvardsAtgard.isPlantleverans){
          <rask-input-number
            class="col-3"
            label="Arealsandel"
            [(ngModel)]="skogsvardTradslagPlanta.arealandel"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            (change)="somethingChanged($event)"
            inputGroupRight="%"
            [min]="0"
            [useDecimalProcessor]="true"
            [isDecimal]="false">
          </rask-input-number>
          <rask-input-number
            class="col-3"
            label="Mål PL/HA"
            [(ngModel)]="skogsvardTradslagPlanta.malPlantorHA"
            [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
            (change)="somethingChanged($event)"
            [useDecimalProcessor]="true"
            [isDecimal]="false">
          </rask-input-number>

        }
      </div>
    </div>
    <div class="col d-flex flex-column">
      <div class="mt-auto mx-auto d-flex">
        <rask-icon-button
          [disabled]="disabled"
          (click)="delete()"
          icon="far fa-trash-alt"
        negative></rask-icon-button>
      </div>
      @if(!skogsvardsAtgard.isPlantleverans){
        <rask-button
          color="tertiary"
          class="d-flex justify-content-center"
          (click)="applyCalculation()"
          ngbTooltip="Beräkna 'plantantal' eller 'mål PL/ha' beroende på vilken som inte är ifylld"
          [disabled]="disabled || recalculateDisabled">
          Räkna
        </rask-button>
      }
    </div>
  </div>
}